class MegaMenu {
  constructor() {
    this.menus = document.querySelectorAll(".header-menu");
    this.mainNav = document.querySelector(".main-nav");
    this.activeMenu = null;
    this.isAnyMenuOpen = false;

    this.init();
  }

  init() {
    // Add click handlers to menu buttons
    this.menus.forEach((menu, index) => {
      if (!menu) return;

      const button = menu.querySelector("button");
      const link = menu.querySelector("a");
      const menuTrigger = button || link; // Use button for non-first items, link for first item
      const content = menu.querySelector(".mega-menu__content");
      const label = content ? content.querySelector(".label") : null;
      const nickname = menu.dataset.menuNickname;
      const isFirstMenu = index === 0;

      // Set the initial label text
      if (nickname && label) {
        label.textContent = nickname.replace(/-/g, " ");
      }

      if (isFirstMenu) {
        // Add hover functionality for the first menu item
        let hoverTimer;

        if (menu) {
          menu.addEventListener("mouseenter", () => {
            // Clear any existing timer
            if (hoverTimer) {
              clearTimeout(hoverTimer);
            }

            // Small delay to prevent accidental triggers
            hoverTimer = setTimeout(() => {
              const menuId = menu.dataset.menuId;

              // Check if any menu is open before closing the current one
              const anyMenuOpen = Array.from(this.menus).some(
                (menu) => menu.getAttribute("data-menu-open") === "true"
              );
              this.isAnyMenuOpen = anyMenuOpen;

              if (this.activeMenu && this.activeMenu !== menuId) {
                this.closeMenu(this.activeMenu, false); // Don't update isAnyMenuOpen when closing
              }

              if (this.activeMenu !== menuId) {
                this.openMenu(menuId);
              }
            }, 100);
          });
        }

        if (menu) {
          menu.addEventListener("mouseleave", () => {
            // Clear the timer if mouse leaves before delay
            if (hoverTimer) {
              clearTimeout(hoverTimer);
            }

            // Close the menu after a short delay to allow moving to submenu
            setTimeout(() => {
              const menuId = menu.dataset.menuId;
              if (this.activeMenu === menuId) {
                // Check if mouse is still over the menu or its content
                const isHoveringMenu = menu.matches(":hover");
                if (!isHoveringMenu) {
                  this.closeMenu(menuId);
                }
              }
            }, 200);
          });
        }

        // Add click handler for first menu (now a link) - allow navigation if menu is already open
        if (link) {
          link.addEventListener("click", (e) => {
            const menuId = menu.dataset.menuId;

            if (this.activeMenu === menuId) {
              // Menu is already open, allow the link to navigate normally
              this.closeMenu(menuId);
              // Don't prevent default - let the link navigate
            } else {
              // Menu is closed, prevent navigation and open the menu instead
              e.preventDefault();
              e.stopPropagation();

              // Check if any menu is open before closing the current one
              const anyMenuOpen = Array.from(this.menus).some(
                (menu) => menu.getAttribute("data-menu-open") === "true"
              );
              this.isAnyMenuOpen = anyMenuOpen;

              if (this.activeMenu) {
                this.closeMenu(this.activeMenu, false); // Don't update isAnyMenuOpen when closing
              }
              this.openMenu(menuId);
            }
          });
        }
      } else {
        // Regular click functionality for other menu items
        if (button) {
          button.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            const menuId = menu.dataset.menuId;

            if (this.activeMenu === menuId) {
              this.closeMenu(menuId);
            } else {
              // Check if any menu is open before closing the current one
              const anyMenuOpen = Array.from(this.menus).some(
                (menu) => menu.getAttribute("data-menu-open") === "true"
              );
              this.isAnyMenuOpen = anyMenuOpen;

              if (this.activeMenu) {
                this.closeMenu(this.activeMenu, false); // Don't update isAnyMenuOpen when closing
              }
              this.openMenu(menuId);
            }
          });
        }
      }

      // Prevent clicks inside the menu from closing it
      if (content) {
        content.addEventListener("click", (e) => {
          e.stopPropagation();
        });
      }
    });

    // Close menu when clicking outside
    document.addEventListener("click", (e) => {
      if (!e.target.closest(".header-menu") && this.activeMenu) {
        this.closeMenu(this.activeMenu);
      }
    });

    // Close menu on escape key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.activeMenu) {
        this.closeMenu(this.activeMenu);
      }
    });
  }

  openMenu(menuId) {
    console.log("openMenu", menuId);
    console.log("isAnyMenuOpen", this.isAnyMenuOpen);
    const menu = document.querySelector(
      `.header-menu[data-menu-id="${menuId}"]`
    );
    if (!menu) return;

    const button = menu.querySelector("button");
    const link = menu.querySelector("a");
    const menuTrigger = button || link;
    const content = menu.querySelector(".mega-menu__content");

    if (button) {
      button.setAttribute("aria-expanded", "true");
    }
    menu.setAttribute("data-menu-open", "true");
    this.mainNav.classList.add("menu-open");
    this.activeMenu = menuId;

    // Add transition class only if no menu was previously open
    if (!this.isAnyMenuOpen) {
      content.classList.add("mega-menu__content--transition");
    }
    content.classList.add("mega-menu__content--active");
    this.isAnyMenuOpen = true;

    // Focus the first link in the menu
    const firstLink = content.querySelector("a");
    if (firstLink) {
      firstLink.focus();
    }
  }

  closeMenu(menuId, updateState = true) {
    console.log("closeMenu", menuId);
    const menu = document.querySelector(
      `.header-menu[data-menu-id="${menuId}"]`
    );
    if (!menu) return;

    const button = menu.querySelector("button");
    const link = menu.querySelector("a");
    const content = menu.querySelector(".mega-menu__content");

    if (button) {
      button.setAttribute("aria-expanded", "false");
    }
    menu.setAttribute("data-menu-open", "false");
    this.mainNav.classList.remove("menu-open");
    this.activeMenu = null;

    if (updateState) {
      // Check if any other menu is still open
      const anyMenuOpen = Array.from(this.menus).some(
        (menu) => menu.getAttribute("data-menu-open") === "true"
      );
      this.isAnyMenuOpen = anyMenuOpen;
    }

    // Remove both classes
    content.classList.remove("mega-menu__content--active");

    if (this.isAnyMenuOpen) {
      content.classList.remove("mega-menu__content--transition");
    }
  }
}

// Initialize the mega menu when the DOM is loaded
document.addEventListener("DOMContentLoaded", () => {
  new MegaMenu();
});
